import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { ShieldAlert, Trash2 } from 'lucide-react';

const Admin = () => {
  const { token, user, API } = useAuth();
  const navigate = useNavigate();
  const [confirmText, setConfirmText] = useState('');
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (user?.role !== 'admin') {
      toast.error('No tienes permisos para acceder a esta sección');
      navigate('/');
    }
  }, [user]);

  const handleDeleteAll = async () => {
    if (confirmText !== 'ELIMINAR') {
      toast.error('Debes escribir ELIMINAR para confirmar');
      return;
    }
    setDeleting(true);
    try {
      const response = await axios.delete(`${API}/documents/delete-all`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success(
        `Eliminados: ${response.data.deleted_documents} documentos, ${response.data.deleted_batches} lotes, ${response.data.deleted_pdfs} PDFs`
      );
      setConfirmText('');
    } catch (error) {
      toast.error('Error al eliminar. Verifica tu conexión e intenta de nuevo.');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-page">
      <div>
        <h1 className="text-4xl md:text-5xl font-bold text-zinc-900 tracking-tight">Administración</h1>
        <p className="text-zinc-500 mt-2">Acciones administrativas del sistema</p>
      </div>

      <Card className="border-red-200 bg-red-50">
        <CardContent className="p-6 space-y-4">
          <div className="flex items-start gap-3">
            <ShieldAlert size={24} className="text-red-600 flex-shrink-0 mt-0.5" />
            <div>
              <h2 className="text-lg font-semibold text-red-900">Eliminar Todo</h2>
              <p className="text-sm text-red-700 mt-1">
                Esto borrará permanentemente TODOS los documentos, lotes y PDFs consolidados
                del servidor. Úsalo solo después de haber descargado y guardado tu ZIP del mes.
                Esta acción no se puede deshacer.
              </p>
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-zinc-700">
              Escribe <span className="font-mono font-bold">ELIMINAR</span> para confirmar:
            </label>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              className="w-full max-w-xs px-3 py-2 border border-zinc-300 rounded-md text-sm"
              placeholder="ELIMINAR"
              data-testid="confirm-delete-input"
            />
          </div>

          <Button
            onClick={handleDeleteAll}
            disabled={confirmText !== 'ELIMINAR' || deleting}
            className="bg-red-600 hover:bg-red-700 text-white disabled:opacity-50"
            data-testid="delete-all-button"
          >
            <Trash2 size={18} className="mr-2" />
            {deleting ? 'Eliminando...' : 'Eliminar Todo'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default Admin;
